import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

export type OcrHistoryFilters = {
  filename: string;
  startDate: string | null; // ISO yyyy-MM-dd or datetime-local value
  endDate: string | null;   // ISO yyyy-MM-dd or datetime-local value
  // Show only documents that require attention: not reviewed and judge verdict is needs_review or fail
  needsAttention: boolean;
};

@Component({
  selector: 'app-ocr-history-filters',
  templateUrl: './ocr-history-filters.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]
})
export class OcrHistoryFiltersComponent {
  filters = input.required<OcrHistoryFilters>();

  filtersChange = output<OcrHistoryFilters>();

  // Emit whenever an input changes
  onFiltersChanged(): void {
    this.filtersChange.emit({ ...this.filters() });
  }
}
